export const buildIframePreviewPath = (
  systemCode?: string,
  assetId?: string,
  alias?: string,
) => {
  if (!assetId) return "";
  const segment = alias?.trim().toLowerCase() || systemCode;
  if (!segment) return "";
  return `/iframe/${segment}/${assetId}`;
};
